import React, { useContext } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { AiOutlineAppstore, AiOutlineDown, AiOutlineLogout, AiOutlineUser } from 'react-icons/ai';
import Cookies from 'js-cookie';

import Context, { IContext } from '../../context/Context';
import tifirelogo from '../../assets/images/tifire.ico';

function iniciais(nome?: string) {
  if (!nome) return '';

  const partes = nome.trim().split(/\s+/);
  const primeira = partes[0]?.[0] || '';
  const ultima = partes.length > 1 ? partes[partes.length - 1][0] : '';

  return (primeira + ultima).toUpperCase();
}

export default function Header() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { caminho } = useParams();

  const { usuario, setUsuario, empresa }: IContext = useContext(Context);

  function handleNavigate() {
    if (pathname === `${caminho}/login`) return;

    if (usuario) {
      navigate(`/${caminho}/menu`);
      return;
    }

    navigate(`/${caminho}/login`);
  }

  function sair() {
    Cookies.remove('usuarioCookie');
    setUsuario(undefined);
    navigate(`/${caminho}/login`);
  }

  return (
    <header className='fixed inset-x-0 top-0 z-50 h-14 pl-[env(safe-area-inset-left)] pr-[env(safe-area-inset-right)] border-b border-zinc-200 bg-white/90 backdrop-blur'>
      <div className='mx-auto flex h-full max-w-5xl items-center justify-between gap-3 px-4'>
        <button
          type='button'
          onClick={handleNavigate}
          className='flex min-w-0 items-center gap-3 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 focus-visible:ring-offset-2'
        >
          <img
            src={empresa?.cod === 1 ?
              'https://imagizer.imageshack.com/img922/545/PK5ZMv.jpg' :
              tifirelogo
            }
            alt='logo'
            className='h-9 w-9 flex-none rounded-lg object-cover'
          />
          <span className='truncate font-semibold text-zinc-900 max-w-[55vw] sm:max-w-xs'>{empresa?.raz}</span>
        </button>

        {usuario && (
          <Menu as='div' className='relative flex-none'>
            <MenuButton className='flex items-center gap-2 rounded-full p-0.5 text-left hover:bg-zinc-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 sm:pr-3'>
              <span className='flex h-9 w-9 items-center justify-center rounded-full bg-zinc-900 text-sm font-semibold text-white'>
                {iniciais(usuario.usu) || <AiOutlineUser className='h-5 w-5' aria-hidden='true' />}
              </span>
              <span className='hidden leading-tight sm:block'>
                <span className='block max-w-[180px] truncate text-sm font-medium text-zinc-900'>{usuario.usu}</span>
                <span className='block text-xs capitalize text-zinc-500'>{usuario.tip?.toLowerCase()}</span>
              </span>
              <AiOutlineDown className='hidden h-3 w-3 text-zinc-500 sm:block' aria-hidden='true' />
              <span className='sr-only'>Abrir menu do usuário</span>
            </MenuButton>

            <MenuItems
              transition
              className='absolute right-0 mt-2 w-60 origin-top-right overflow-hidden rounded-xl border border-zinc-200 bg-white shadow-card focus:outline-none transition duration-100 ease-out data-[closed]:scale-95 data-[closed]:opacity-0'
            >
              <div className='border-b border-zinc-100 px-4 py-3'>
                <p className='truncate text-sm font-semibold text-zinc-900'>{usuario.usu}</p>
                <span className='mt-1 inline-block rounded-full bg-zinc-100 px-2 py-0.5 text-[11px] font-medium uppercase tracking-wide text-zinc-600'>
                  {usuario.tip}
                </span>
              </div>
              <div className='p-1'>
                <MenuItem>
                  <button
                    type='button'
                    onClick={() => navigate(`/${caminho}/menu`)}
                    className='flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-zinc-700 data-[focus]:bg-zinc-100 data-[focus]:text-zinc-900'
                  >
                    <AiOutlineAppstore className='h-4 w-4' aria-hidden='true' />
                    Menu principal
                  </button>
                </MenuItem>
                <MenuItem>
                  <button
                    type='button'
                    onClick={sair}
                    className='flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-rose-600 data-[focus]:bg-rose-50'
                  >
                    <AiOutlineLogout className='h-4 w-4' aria-hidden='true' />
                    Sair
                  </button>
                </MenuItem>
              </div>
            </MenuItems>
          </Menu>
        )}
      </div>
    </header>
  );
}
